import { Component} from '@angular/core';
import { DbService } from '../_services/db.service';
import {GefundenComponent} from './gefunden.component';
import {AuthenticationService} from '../_services';

@Component({
  selector: 'app-gefunden-mobile',
  templateUrl: './gefunden.component.mobile.html',
  styleUrls: ['../home/home.component.mobile.css']
})
export class GefundenMobileComponent extends GefundenComponent{

  constructor(
    service: DbService,
    authenticationService: AuthenticationService) {
    super(service, authenticationService);
  }

}
